import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineStepList のスタイル
 */
export const hotlineStepListStyle = tv({
    slots: {
        base: [
            'flex flex-col gap-y-8 lg:gap-y-16',
            'bg-blue-gray-75',
            'rounded-md',
            'pt-16 pb-32 lg:pb-16 px-16',
        ],
        baseTitle: [textStyle({ color: 'base', isBold: true, size: 'sm' })],
        item: [
            'w-full',
            'list-none',
            'rounded-md',
            'pt-8 pb-12 px-12',
            'bg-white',
            'relative',
            'after:absolute after:-bottom-32 lg:after:bottom-[calc(50%_-_15px)] after:right-[calc(50%_-_7px)] lg:after:-right-36',
            'after:w-[30px] lg:after:w-[20px] after:h-[20px] lg:after:h-[30px]',
            'after:bg-navy-100',
            'after:[clip-path:polygon(0_0,100%_0,_50%_100%)] lg:after:[clip-path:polygon(0_0,_0_100%,_100%_50%)]',
        ],
        itemContent: ['flex flex-col gap-y-8'],
        itemContentDescription: [textStyle({ color: 'base', size: 'sm' })],
        itemContentTitle: [
            textStyle({ color: 'base', isBold: true, size: 'sm' }),
            'whitespace-pre-line',
        ],
        itemInner: ['flex flex-col items-center gap-y-8'],
        itemTitle: [
            textStyle({ color: 'white', isBold: true, size: 'sm' }),
            'text-left',
            'inline',
            'py-2 px-4',
            'bg-turquoise-blue-100',
            '-translate-x-8 lg:-translate-x-4',
        ],
        list: ['flex flex-col lg:items-stretch lg:flex-row gap-44 lg:gap-52'],
    },
    variants: {
        isLastItem: {
            false: {
                item: ['after:content-[">"]'],
            },
            true: {
                item: ['after:content-none'],
            },
        },
    },
});
